<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <app-detail-container #alertSettingsContainerComponent [containerHeader]="alertFrequencyContainerHeader" [collapsedContainerHeader]="alertFrequencyCollapsedContainerHeader"
                            [containerHeaderAction]="alertFrequencyAction">
        <ng-template #alertFrequencyContainerHeader>
          Alert Frequency
        </ng-template>

        <ng-template #alertFrequencyCollapsedContainerHeader>
          Alert Frequency
        </ng-template>

        <ng-template #alertFrequencyAction>
          <app-eca-ghost-btn class="title-action-button float-right" btnText="Edit Frequency" btnIcon="edit"
                             btnType="primary" [disable]='isAlertSettingsLoading'
                             *ngIf="!editingDetails"
                             (btnClicked)="editDetails()"></app-eca-ghost-btn>
          <span class="float-right" *ngIf="editingDetails">
            <app-eca-ghost-btn btnText="Save" btnIcon="save" btnType="success"
                               [disable]='isAlertSettingsLoading' (btnClicked)="saveDetails()"></app-eca-ghost-btn>
            <app-eca-ghost-btn btnText="Cancel" btnIcon="times" btnType="danger"
                               [disable]='isAlertSettingsLoading' (btnClicked)="cancelEdit()"></app-eca-ghost-btn>
          </span>
        </ng-template>
        <div *ngIf="isAlertSettingsLoading" class="text-center">
          <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x" primaryColor="darkgreen" secondaryColor="green"></fa-duotone-icon>
        </div>
        <div *ngIf="!isAlertSettingsLoading">
          <div class="col">
            <app-alert-settings-editor [companyAlertSettings]="tempCompanyAlertSetting" [editingType]="editingDetails" [saveAttempted]="saveAttempted"></app-alert-settings-editor>
          </div>
        </div>
      </app-detail-container>
      <app-detail-container #alertSettingsContainerComponent [containerHeader]="alertRecipientContainerHeader" [collapsedContainerHeader]="alertRecipientCollapsedContainerHeader"
                            [containerHeaderAction]="alertRecipientAction">
        <ng-template #alertRecipientContainerHeader>
          Alert Recipients
        </ng-template>

        <ng-template #alertRecipientCollapsedContainerHeader>
          Alert Recipients
        </ng-template>

        <ng-template #alertRecipientAction>
          <app-eca-ghost-btn class="title-action-button float-right" btnText="Add Recipient Email" btnIcon="add"
                             btnType="success"
                             (btnClicked)="addRecipientEmailClick()"></app-eca-ghost-btn>
        </ng-template>
        <div *ngIf="isAlertSettingsLoading" class="text-center">
          <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x" primaryColor="darkgreen" secondaryColor="green"></fa-duotone-icon>
        </div>
        <div *ngIf="!isAlertSettingsLoading">
          <div class="col">
            <app-alert-email-editor [emailAddresses]="tempCompanyAlertEmailSetting"
                                    [editingType]="editingDetails"
                                    [saveAttempted]="saveAttempted"
                                    (removeEmail)="removeEmailClick($event)"
                                    (addRecipientEmail)="addRecipientEmailClick($event)"></app-alert-email-editor>
          </div>
        </div>
      </app-detail-container>
    </div>
  </div>
</div>
